import { call, put } from 'redux-saga/effects';
import CarFirmwaresActions from '../redux/CarFirmwaresRedux';
import MessagesActions from '../redux/MessagesRedux';

export function* getCarFirmwares(api, action) {
  const response = yield call(api.getFirmwareCars, { ...action.props });

  if (response.ok) {
    yield put(CarFirmwaresActions.carFirmwaresSuccess({ ...response.data, ...action.props }));
  } else {
    yield put(CarFirmwaresActions.carFirmwaresFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({ type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem }));
  }
}

export function* downloadXlsByFilter(api, action) {

  const response = yield call(api.getDownloadUrlXlsCars, { ...action.params });

  if (response.ok) {
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const downloadUrl = window.URL.createObjectURL(blob);

    
    console.log("DOWNLOAD URL", downloadUrl);
    const link = document.createElement('a');
    link.href = downloadUrl;

    // Извлекаем имя файла из заголовка
    let contentDisposition = response.headers['content-disposition'];
    let filename = contentDisposition?.split(';').find(part => part.trim().startsWith('filename='))?.split('=')[1]?.trim();
    if (filename) {
      filename = filename.replace(/['"]/g, '');
    } else {
      filename = `report_${Date.now()}.xlsx`;
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(downloadUrl);

    yield put(CarFirmwaresActions.downloadXlsByFilterSuccess('reposrt'));
  } else {
    yield put(CarFirmwaresActions.downloadXlsByFilterFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({ type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem }));
  }
}
